/**
 * Created by Ning Jiang on 11/24/2016.
 */

import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class HorribleHeroesSoundConfig implements ISoundConfig {
    public static instance: HorribleHeroesSoundConfig = new HorribleHeroesSoundConfig();
    public static readonly AS_WIN: string = "asWin";
    public static readonly AS_WIN_BIG: string = "asWinBig";
    public static readonly WIN_LARGE: string = "winLarge";
    public static readonly WIN_MEDIUM: string = "winMedium";
    public static readonly WIN_SMALL: string = "winSmall";
    public static readonly WIN_TINY: string = "winTiny";
    public static readonly BIG_WIN: string = "winBig";
    public static readonly MEGA_WIN: string = "winMega";
    public static readonly SUPER_MEGA_WIN: string = "winSuperMega";

    public readonly MAIN_GAME_AMBIANCE_1: string = "background-music-main";
    public readonly BACKGROUND_MUSIC_FS: string = "background-music-fs";
    public readonly BACKGROUND_MUSIC_FS_SUPER: string = "background-music-fs-super";

    public readonly REELS_SPIN: string = "reelsSpinning";
    public readonly REELS_DEFAULT_BOUNCE: string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];

    // Heroes intro splash
    INTRO_SPLASH_IN: string = "introSplashIn";
    INTRO_SPLASH_OUT: string = "introSplashOut";

    // Scatter sounds
    SCATTER: string = "scatter"; // this sound is used along with scatter count.
    SCATTER_FAIL: string = "scatterFail";
    SCATTER_ANTICIPATION: string = "scatterAnticipation";
    SCATTER_EXPLODE: string = "scatterExplode";
    SCATTER_ANTICIPATION_ALARM: string = "scatterAnticipationAlarm";
    SCATTER_ANTICIPATION_FAIL: string = "scatterAnticipationFail";
    SCATTER_ANTICIPATION_WIN: string = "scatterAnticipationWin";
    FS_WIN_ATTENTION: string = "fsWinAttention";

    // FS intro/outro
    FS_SELECT_FADE_IN: string = "fsSelectFadein";
    FS_SELECT: string = "fsSelect";
    FS_START_DOOR_CLOSE: string = "fsStartDoorClose";
    FS_START_DOOR_OPEN: string = "fsStartDoorOpen";
    FS_ENDS: string = "fsEnds";
    FS_ENDS_BAD: string = "fsEndsBad";
    COUNT_UP_ENDS_FS_OUTRO: string = "countupEndsFsOutro";

    // Toxic hazard -> FS_LOW
    TOXIC_SHUFFLE: string = "toxicShuffle";
    TOXIC_WILD: string = "toxicWild";
    TOXIC_WILD_4: string = "toxicWild4";
    TOXIC_WILD_5: string = "toxicWild5";

    // Betline
    BETLINE_SWEEP: string[] = ["betlineSweep1", "betlineSweep2", "betlineSweep3", "betlineSweep4"];

    // Win Count Up
    COUNT_UP: string = "countup";
    COUNT_UP_FIRE: string = "countupFire";
    COUNT_UP_ENDS_TINY: string = "countupEndsTiny";
    COUNT_UP_ENDS_SMALL: string = "countupEndsSmall";
    COUNT_UP_ENDS_MEDIUM: string = "countupEndsMedium";
    COUNT_UP_ENDS_LARGE: string = "countupEndsLarge";

    // Big Win
    BIG_WIN_INITIAL_WIN: string = "bigwinInitialWin";
    BIG_WIN_LEVEL: string = "bigwinLevel"; // this will be used along with the level count.
    BIG_WIN_ENDS: string = "bigwinEnds";
    BIG_WIN_ENDS_LEVEL5: string = "bigwinEndsLevel5";

    // FS random lightening
    LIGHTNING: string = "lightning"; // this will be used along with the random count(1, 2 or 3).

    FS_PLUS_SPIN: string = "fsPlusSpin";

    FS_METER_EXPLODE: string = "fsMeterExplode";

    FS_MAYHEM_SPLASH: string = "fsMayhemSplash";

    MX_LANDING: string = "mxLanding";

    WILD_LANDING: string = "wildLanding";

    WILD_LANDING_LOCK: string = "wildLandingLock";
    FS_WILD_MULTIPLIER: string = "fsWildMultiplier";

    // X Ways
    X_WAYS_LANDING: string = "xwaysLanding";
    X_WAYS_ANTICIPATION: string = "xwaysAnticipation";
    X_WAYS_ELECTRICITY: string = "xwaysElectricity";
    X_WAYS_REVEAL: string = "xwaysReveal";
    X_WAYS_EXPAND_INFECTIOUS: string = "xwaysExpandInfectious";
    X_WAYS_REVEAL_INFECTIOUS: string = "xwaysRevealInfectious";

    // Cap win -> End of Days
    CAP_WIN_BETLINE_SWEEEP: string = "capWinBetlineSweep";
    CAP_WIN_FADE_IN: string = "capWinFadeIn";
    CAP_WIN_COUNT_UP: string = "capWinCountup";
    CAP_WIN_COUNT_UP_ENDS: string = "capWinCountupEnds";
    BACKGROUND_MUSIC_CAP_WIN: string = "background-music-cap-win";
    CAP_WIN_ENDS: string = "capWinEnds";

    constructor() {
        if (HorribleHeroesSoundConfig.instance) {
            throw new Error("HorribleHeroesSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}